/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Filename_LabelInputs */

const en_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const fr_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de fichier`)
};

const de_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiname`)
};

const it_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del file`)
};

const ru_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя файла`)
};

const es_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del archivo`)
};

const zh_cn2_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件名`)
};

const ja_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル名`)
};

const hi_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइलनाम`)
};

const pt_pt2_markers_filename_label = /** @type {(inputs: Markers_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do arquivo`)
};

/**
* | output |
* | --- |
* | "Filename" |
*
* @param {Markers_Filename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_filename_label = /** @type {((inputs?: Markers_Filename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Filename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_filename_label(inputs)
	if (locale === "de") return de_markers_filename_label(inputs)
	if (locale === "it") return it_markers_filename_label(inputs)
	if (locale === "ru") return ru_markers_filename_label(inputs)
	if (locale === "es") return es_markers_filename_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_filename_label(inputs)
	if (locale === "ja") return ja_markers_filename_label(inputs)
	if (locale === "hi") return hi_markers_filename_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_filename_label(inputs)
	return en_markers_filename_label(inputs)
});